var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProgressed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18.5C13.9706 18.5 18 14.4706 18 9.5C18 4.52944 13.9706 0.5 9 0.5C4.02944 0.5 0 4.52944 0 9.5C0 14.4706 4.02944 18.5 9 18.5ZM5.45592 9.66505L7.484 11.3754L12.8846 5.92159C13.1086 5.69536 13.4733 5.69246 13.7009 5.91511C13.9304 6.13966 13.9334 6.50812 13.7075 6.73631L8.04264 12.4586C7.76782 12.7362 7.32593 12.7564 7.02695 12.5049L4.70716 10.5542C4.46174 10.3478 4.42982 9.98168 4.63583 9.73595C4.84249 9.48947 5.21004 9.45769 5.45592 9.66505Z",
    fill: "#1D8157"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProgressed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/progressed.2f4dfe081412448b6e02d5c2a5a03b04.svg";